import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import db from "../Firebase";

import {
    collection,
    onSnapshot,
    addDoc,
    deleteDoc,
    doc,
    serverTimestamp,
} from "firebase/firestore";

import {
    getStorage,
    ref,
    uploadBytes,
    getDownloadURL,
    deleteObject,
} from "firebase/storage";

function CardsPage() {
    const [cards, setCards] = useState([]);
    const [filteredCards, setFilteredCards] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("All");

    const [name, setName] = useState("");
    const [category, setCategory] = useState("");
    const [paid, setPaid] = useState(false);
    const [status, setStatus] = useState("1");
    const [imageFile, setImageFile] = useState(null);

    const storage = getStorage();

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "nv_cards"), (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));

            data.sort(
                (a, b) =>
                    (b.created_date?.seconds || 0) -
                    (a.created_date?.seconds || 0)
            );

            setCards(data);
            setFilteredCards(data);

            const uniqueCategories = [
                ...new Set(data.map((item) => item.category).filter(Boolean)),
            ];
            setCategories(uniqueCategories);
        });

        return () => unsubscribe();
    }, []);

    const handleFilter = (cat) => {
        setSelectedCategory(cat);

        if (cat === "All") {
            setFilteredCards(cards);
        } else {
            setFilteredCards(cards.filter((item) => item.category === cat));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !category || !imageFile) {
            Swal.fire("Error", "All fields are required!", "error");
            return;
        }

        try {
            const imageRef = ref(
                storage,
                `nv_cards/${Date.now()}_${imageFile.name}`
            );

            await uploadBytes(imageRef, imageFile);
            const imageUrl = await getDownloadURL(imageRef);

            await addDoc(collection(db, "nv_cards"), {
                name,
                category,
                paid,
                status,
                image_url: imageUrl,
                created_date: serverTimestamp(),
            });

            Swal.fire("Success", "Card added successfully!", "success");

            setName("");
            setCategory("");
            setPaid(false);
            setStatus("1");
            setImageFile(null);
        } catch (error) {
            Swal.fire("Error", "Upload failed!", "error");
        }
    };

    const handleDelete = async (id, imageUrl) => {
        const confirm = await Swal.fire({
            title: "Delete Card?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
        });

        if (!confirm.isConfirmed) return;

        try {
            await deleteDoc(doc(db, "nv_cards", id));

            const imageRef = ref(storage, imageUrl);
            await deleteObject(imageRef);

            Swal.fire("Deleted!", "Card removed.", "success");
        } catch (error) {
            Swal.fire("Error", "Delete failed!", "error");
        }
    };

    const CATEGORY_OPTIONS = [
        { value: "diy_post", label: "DIY Post" },
        { value: "e_invites", label: "E Invites" },
        { value: "diy_story", label: "DIY Story" },
    ];

    return (
        <>
            {/* HEADER */}
            <div className="bg-dark text-white py-3 px-4 d-flex justify-content-between align-items-center shadow-sm">
                <h5 className="mb-0 fw-bold">🖼 Cards Management</h5>
                <Link to="/">
                    <img
                        src="/images/menubutton.png"
                        alt="Menu"
                        style={{ height: "2rem", filter: "invert(1)" }}
                    />
                </Link>
            </div>

            <div className="container py-4">

                {/* FILTER PILLS */}
                <div className="mb-4 text-center">
                    <button
                        className={`btn rounded-pill px-4 me-2 mb-2 ${selectedCategory === "All"
                            ? "btn-dark shadow"
                            : "btn-outline-dark"
                            }`}
                        onClick={() => handleFilter("All")}
                    >
                        All
                    </button>

                    {categories.map((cat) => (
                        <button
                            key={cat}
                            className={`btn rounded-pill px-4 me-2 mb-2 ${selectedCategory === cat
                                ? "btn-dark shadow"
                                : "btn-outline-dark"
                                }`}
                            onClick={() => handleFilter(cat)}
                        >
                            {cat}
                        </button>
                    ))}
                </div>

                {/* UPLOAD FORM */}
                {/* <div
                    className="card border-0 shadow-lg p-4 mb-5"
                    style={{ borderRadius: "18px" }}
                >
                    <h6 className="fw-bold mb-3">➕ Add New Card</h6>

                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>

                            <div className="col-md-3">
                                <select
                                    className="form-select"
                                    value={category}
                                    onChange={(e) => setCategory(e.target.value)}
                                >
                                    <option value="">Select Category</option>
                                    {CATEGORY_OPTIONS.map((cat) => (
                                        <option key={cat.value} value={cat.value}>
                                            {cat.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-2">
                                <select
                                    className="form-select"
                                    value={paid}
                                    onChange={(e) =>
                                        setPaid(e.target.value === "true")
                                    }
                                >
                                    <option value="false">Free</option>
                                    <option value="true">Paid</option>
                                </select>
                            </div>

                            <div className="col-md-2">
                                <select
                                    className="form-select"
                                    value={status}
                                    onChange={(e) =>
                                        setStatus(e.target.value)
                                    }
                                >
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                            </div>

                            <div className="col-md-2">
                                <input
                                    type="file"
                                    className="form-control"
                                    accept="image/*"
                                    onChange={(e) =>
                                        setImageFile(e.target.files[0])
                                    }
                                />
                            </div>
                        </div>

                        <button className="btn btn-dark rounded-pill px-4 mt-4">
                            Upload Card
                        </button>
                    </form>
                </div> */}

                {/* EMPTY STATE */}
                {filteredCards.length === 0 && (
                    <div className="text-center text-muted py-5">
                        <h6>No Cards Found</h6>
                    </div>
                )}

                {/* CARD GRID */}
                <div className="row g-4">
                    {filteredCards.map((card) => (
                        <div className="col-auto" key={card.id}>
                            {(() => {
                                const c = card.category;
                                const imgW = c === "diy_story" ? 270 : c === "e_invites" ? 270 : 340;
                                const imgH = c === "diy_story" ? 480 : c === "e_invites" ? 480 : 340;
                                return (
                                    <div
                                        className="card border-0 shadow-lg"
                                        style={{
                                            borderRadius: "18px",
                                            transition: "0.3s ease",
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "relative",
                                                width: `${imgW}px`,
                                                height: `${imgH}px`,
                                                overflow: "hidden",
                                                borderRadius: "18px 18px 0 0",
                                            }}
                                        >
                                            <img
                                                src={card.image_url}
                                                alt={card.name}
                                                style={{
                                                    width: `${imgW}px`,
                                                    height: `${imgH}px`,
                                                    display: "block",
                                                }}
                                            />

                                            {/* Hover Zoom */}
                                            <div
                                                className="position-absolute top-0 start-0 w-100 h-100"
                                                style={{
                                                    background:
                                                        "linear-gradient(to top, rgba(0,0,0,0.5), transparent)",
                                                }}
                                            ></div>

                                            {/* Delete Floating */}
                                            <button
                                                onClick={() =>
                                                    handleDelete(
                                                        card.id,
                                                        card.image_url
                                                    )
                                                }
                                                className="btn btn-danger btn-sm position-absolute"
                                                style={{
                                                    top: "15px",
                                                    right: "15px",
                                                    borderRadius: "50px",
                                                }}
                                            >
                                                🗑
                                            </button>
                                        </div>

                                        <div className="card-body d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="mb-1">{card.name}</h6>
                                                <small className="text-muted">
                                                    {card.category}
                                                </small>
                                            </div>

                                            <div className="text-end">
                                                <span
                                                    className={`badge ${card.paid
                                                        ? "bg-success"
                                                        : "bg-secondary"
                                                        } mb-1`}
                                                >
                                                    {card.paid ? "Paid" : "Free"}
                                                </span>
                                                <br />
                                                <span
                                                    className={`badge ${card.status === "1"
                                                        ? "bg-dark"
                                                        : "bg-danger"
                                                        }`}
                                                >
                                                    {card.status === "1"
                                                        ? "Active"
                                                        : "Inactive"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default CardsPage;


// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import db from "../Firebase";

// import {
//     collection,
//     onSnapshot,
//     addDoc,
//     deleteDoc,
//     doc,
//     serverTimestamp,
// } from "firebase/firestore";

// import {
//     getStorage,
//     ref,
//     uploadBytes,
//     getDownloadURL,
//     deleteObject,
// } from "firebase/storage";

// function CardsPage() {
//     const [cards, setCards] = useState([]);
//     const [filteredCards, setFilteredCards] = useState([]);
//     const [categories, setCategories] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState("All");

//     const [name, setName] = useState("");
//     const [category, setCategory] = useState("");
//     const [paid, setPaid] = useState(false);
//     const [status, setStatus] = useState("1");
//     const [imageFile, setImageFile] = useState(null);

//     const storage = getStorage();

//     // Fetch Data
//     useEffect(() => {
//         const unsubscribe = onSnapshot(collection(db, "nv_cards"), (snapshot) => {
//             const data = snapshot.docs.map((doc) => ({
//                 id: doc.id,
//                 ...doc.data(),
//             }));

//             // Sort by created_date desc
//             data.sort(
//                 (a, b) =>
//                     (b.created_date?.seconds || 0) -
//                     (a.created_date?.seconds || 0)
//             );

//             setCards(data);

//             // Extract Unique Categories
//             const uniqueCategories = [
//                 ...new Set(data.map((item) => item.category).filter(Boolean)),
//             ];
//             setCategories(uniqueCategories);

//             setFilteredCards(data);
//         });

//         return () => unsubscribe();
//     }, []);

//     // Filter Handler
//     const handleFilter = (cat) => {
//         setSelectedCategory(cat);

//         if (cat === "All") {
//             setFilteredCards(cards);
//         } else {
//             const filtered = cards.filter((item) => item.category === cat);
//             setFilteredCards(filtered);
//         }
//     };

//     // Upload Card
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!name || !category || !imageFile) {
//             Swal.fire("Error", "All fields are required!", "error");
//             return;
//         }

//         try {
//             const imageRef = ref(
//                 storage,
//                 `nv_cards/${Date.now()}_${imageFile.name}`
//             );

//             await uploadBytes(imageRef, imageFile);
//             const imageUrl = await getDownloadURL(imageRef);

//             await addDoc(collection(db, "nv_cards"), {
//                 name,
//                 category,
//                 paid,
//                 status,
//                 image_url: imageUrl,
//                 created_date: serverTimestamp(),
//             });

//             Swal.fire("Success", "Card added successfully!", "success");

//             setName("");
//             setCategory("");
//             setPaid(false);
//             setStatus("1");
//             setImageFile(null);
//         } catch (error) {
//             console.error(error);
//             Swal.fire("Error", "Upload failed!", "error");
//         }
//     };

//     // Delete Card
//     const handleDelete = async (id, imageUrl) => {
//         const confirm = await Swal.fire({
//             title: "Are you sure?",
//             text: "This will delete the card permanently.",
//             icon: "warning",
//             showCancelButton: true,
//         });

//         if (!confirm.isConfirmed) return;

//         try {
//             await deleteDoc(doc(db, "nv_cards", id));

//             // Delete image from storage
//             const imageRef = ref(storage, imageUrl);
//             await deleteObject(imageRef);

//             Swal.fire("Deleted!", "Card removed.", "success");
//         } catch (error) {
//             console.error(error);
//             Swal.fire("Error", "Delete failed!", "error");
//         }
//     };

//     return (
//         <>
//             <div className="p-2 d-flex justify-content-between">
//                 <Link to="/">
//                     <img
//                         src="/images/menubutton.png"
//                         alt="Menu"
//                         style={{ height: "2rem" }}
//                     />
//                 </Link>
//             </div>

//             <div className="container mt-3">
//                 <h5>Cards Management Page ({cards.length})</h5>

//                 {/* FILTER BUTTONS */}
//                 <div className="mb-3">
//                     <button
//                         className={`btn btn-sm ${selectedCategory === "All"
//                             ? "btn-primary"
//                             : "btn-outline-primary"
//                             } me-2`}
//                         onClick={() => handleFilter("All")}
//                     >
//                         All
//                     </button>

//                     {categories.map((cat) => (
//                         <button
//                             key={cat}
//                             className={`btn btn-sm ${selectedCategory === cat
//                                 ? "btn-primary"
//                                 : "btn-outline-primary"
//                                 } me-2`}
//                             onClick={() => handleFilter(cat)}
//                         >
//                             {cat}
//                         </button>
//                     ))}
//                 </div>

//                 {/* UPLOAD FORM */}
//                 <div className="card p-3 mb-4">
//                     <h6>Add New Card</h6>

//                     <form onSubmit={handleSubmit}>
//                         <div className="row">
//                             <div className="col-md-3">
//                                 <input
//                                     type="text"
//                                     className="form-control mb-2"
//                                     placeholder="Name"
//                                     value={name}
//                                     onChange={(e) => setName(e.target.value)}
//                                 />
//                             </div>

//                             <div className="col-md-3">
//                                 <input
//                                     type="text"
//                                     className="form-control mb-2"
//                                     placeholder="Category"
//                                     value={category}
//                                     onChange={(e) => setCategory(e.target.value)}
//                                 />
//                             </div>

//                             <div className="col-md-2">
//                                 <select
//                                     className="form-control mb-2"
//                                     value={paid}
//                                     onChange={(e) => setPaid(e.target.value === "true")}
//                                 >
//                                     <option value="false">Free</option>
//                                     <option value="true">Paid</option>
//                                 </select>
//                             </div>

//                             <div className="col-md-2">
//                                 <select
//                                     className="form-control mb-2"
//                                     value={status}
//                                     onChange={(e) => setStatus(e.target.value)}
//                                 >
//                                     <option value="1">Active</option>
//                                     <option value="0">Inactive</option>
//                                 </select>
//                             </div>

//                             <div className="col-md-2">
//                                 <input
//                                     type="file"
//                                     className="form-control mb-2"
//                                     accept="image/*"
//                                     onChange={(e) => setImageFile(e.target.files[0])}
//                                 />
//                             </div>
//                         </div>

//                         <button className="btn btn-success btn-sm mt-2">
//                             Upload Card
//                         </button>
//                     </form>
//                 </div>

//                 {/* CARD LIST */}
//                 <div className="row">
//                     {filteredCards.map((card) => (
//                         <div className="col-md-3 mb-4" key={card.id}>
//                             <div className="card shadow-sm">
//                                 <img
//                                     src={card.image_url}
//                                     alt={card.name}
//                                     className="card-img-top"
//                                     style={{ height: "200px", objectFit: "cover" }}
//                                 />

//                                 <div className="card-body">
//                                     <h6>{card.name}</h6>
//                                     <p className="mb-1">
//                                         <strong>Category:</strong> {card.category}
//                                     </p>
//                                     <p className="mb-1">
//                                         <strong>Paid:</strong> {card.paid ? "Yes" : "No"}
//                                     </p>
//                                     <p className="mb-1">
//                                         <strong>Status:</strong>{" "}
//                                         {card.status === "1" ? "Active" : "Inactive"}
//                                     </p>

//                                     <button
//                                         className="btn btn-danger btn-sm mt-2"
//                                         onClick={() =>
//                                             handleDelete(card.id, card.image_url)
//                                         }
//                                     >
//                                         Delete
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </>
//     );
// }

// export default CardsPage;